(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('InvoiceGridDTO', InvoiceGridDTO);

    InvoiceGridDTO.$inject = ['$resource','DateUtils'];

    function InvoiceGridDTO($resource, DateUtils) {
        var resourceUrl = "api/invoiceGridDTO/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET',isArray: true},
            'get': {
                method: 'GET',
                transformResponse:function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.invoiceDate = DateUtils.convertLocalDateFromServer(data.invoiceDate);
                    }
                    return data;
                }
            }
        });
    }
})();
